import React, { useState } from "react";
import { StandadCard } from "../../components/Cards";
import { PageContainer } from "../../components/container/PageContainer";
import { Breadcrumb } from "../../layout/fullLayout/breadcrumb/Breadcrumb";
import { IBreadcrumbProps } from "../../layout/fullLayout/breadcrumb/IBreadcrumbProps";
import {
  Grid,
  MenuItem,
  Button,
  Divider,
  Box,
  Tabs,
  Tab,
  Card,
  CircularProgress,
  Typography,
  Avatar,
} from "@mui/material";
import {
  CustomFormLabel,
  CustomSelect,
  CustomTextField,
  CustomTypography,
} from "../../components/formsComponents";
import { a11yProps } from "../../components/Tabs/utils";
import { Add, Feed, GridView, Money, Description } from "@mui/icons-material";
import { TabPanel } from "../../components/Tabs/TabPanel";
import { PackageView } from "./components/PackageView/PackageView";
import { ComplaintLog } from "./components/ComplaintLog/ComplaintLog";
import { useAuth } from "../../contexts/AuthProvider/AuthProvider";
import { useMessagesPopup } from "../../contexts/MessagesPopupProvider/MessagesPopupProvider";
import { api } from "../../api/api";
import { IUserMembership } from "../../constants/commonTypes";
import { AddVehicle } from "./components/ComplaintLog/AddVehicle/Addvehicle";
import { LoadState } from "../../constants/enums";
import { PaidComplaintLog } from "./components/PaidComplaint/paidComplaint";
import { IComplaintDetails, IServiceDetails } from "./interface/IComplaint";
import {
  IDataTableProps,
  MobileLogoRenderType,
  RenderType,
} from "../../components/Table/interfaces/IDataTableProps";
import { DateFilterDropdown } from "../../components/Table/components/DateFilterDropdown/DateFilterDropdown";
import { useDateFilter } from "../../components/Table/hooks/useDateFilter";
import { CustomDatePicker } from "../../components/formsComponents/CustomPicker";
import moment from "moment";
import { CSVExportPlugin, RefreshPlugin } from "../../components/Table/plugins";
import { formatDateWithTime } from "../../helpers";
import { CustomChip } from "../../components/CustomChip";
import { DataTable } from "../../components/Table/DataTable";
import { ComplaintReport } from "./components/ComplaintReport/ComplaintReport";
import { ServiceDetails } from "./components/ServiceDetails/ServiceDetails";

export type searchType = "Mobile Number" | "Vehicle Number";

export const Complaint: React.FC = () => {
  // const BCrumb: IBreadcrumbProps["items"] = [
  //   {
  //     to: "/",
  //     title: "ccl-main",
  //   },
  //   {
  //     title: "ccl-complaint",
  //   },
  // ];

  const [tablePagination, setTablePagination] = React.useState({
    pageNumber: 1,
    rowsInPerPage: 5,
  });

  const [searchType, setSearchType] =
    React.useState<searchType>("Mobile Number");
  const [value, setValue] = React.useState("");
  const [vechicleNumber, setvehicleNumber] = React.useState(0);
  const [memberShipId, setMemberShipId] = React.useState("");
  const [tab, setTab] = React.useState(0);
  const [Loading, setLoading] = React.useState(false);
  const { showTopErrorSnackbar } = useMessagesPopup();
  const [transactions, setTransactions] = React.useState<IUserMembership[]>([]);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const isTranactionsExists = transactions.length > 0;
  const auth = useAuth();
  const [familyPlan, setFamilyPlan] = React.useState<boolean>(false);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  const [serviceDetails, setServiceDetails] = useState<IServiceDetails>();
  const [complaintDetails, setComplaintDetails] = useState<IComplaintDetails[]>(
    []
  );

  const {
    date,
    type,
    handleDateSelectChange,
    dateDropdownList,
    setDate,
    setType,
  } = useDateFilter();

  const [vehicleNo, setVehicleNo] = React.useState("");
  const [complaintLoading, setComplaintLoading] = React.useState(false);

  const [familyPlanData, setFamilyPlanData] =
    React.useState<IUserMembership | null>(null);
  const [loading, setloading] = React.useState<LoadState>(LoadState.NotLoaded);

  const handleSearch = async () => {
    if (auth.user.isLogin && auth.user.tokens) {
      try {
        setTransactions([]);
        setLoading(true);
        setloading(LoadState.InProgress);
        const url =
          searchType === "Mobile Number"
            ? `/check-vehicle-phone-exist?phone_number=${value}`
            : searchType === "Vehicle Number" ? `/check-vehicle-phone-exist?vehicle_number=${value}` : `/check-vehicle-phone-exist?certificate_number=${value}`;
        const res = await api.get(url, {
          headers: {
            "auth-Token": auth.user.tokens.access,
          },
        });

        const data: IUserMembership[] | string = res.data.data;

        if (Array.isArray(data)) {
          setTransactions(data);
          setvehicleNumber(0);
          setMemberShipId(data[0].membership_code.toString());

          setVehicleNo(data[0].vehicle_number);

          const familyPlan = data.find(
            (item) =>
              (item.package_id === 21 ||
                item.package_id === 22 ||
                item.package_id === 23) &&
              item.status === "ACTIVE"
          );

          if (familyPlan) {
            setFamilyPlanData(familyPlan);
            setFamilyPlan(true);
            const familyPlanIndex = data.indexOf(familyPlan);
            console.log("Family Plan Index:", familyPlanIndex);
          }
        } else {
          showTopErrorSnackbar("No Record found!!");
        }
      } catch (err) {
        showTopErrorSnackbar("Something went to be wrong!!");
      } finally {
        setLoading(false);
        setloading(LoadState.Loaded);
      }
    }
  };

  const fetchMembershipDetails = async () => {
    if (auth.user.isLogin && auth.user.tokens && transactions.length !== 0) {
      try {
        setComplaintLoading(true);
        const url = memberShipId.startsWith("3388")
          ? `/get-service-and-complaint-for-cc?membership_code=${memberShipId}`
          : `/get-service-and-complaint-for-cc?membership_code=${memberShipId}&membership_type=OLD`;

        const res = await api.get(url, {
          headers: {
            "auth-Token": auth.user.tokens.access,
          },
        });
        setComplaintDetails(res.data.resultComplaint);
        setTotalRecords(res.data.complaintLength);

        if (res.data.resultService.length > 0) {
          // Set the first item in the resultService array
          setServiceDetails(res.data.resultService[0]);
        }

        console.log(res);
      } catch (err) {
        showTopErrorSnackbar("Something went wrong!!");
      } finally {
        setLoading(false);
      }
    }
  };

  React.useEffect(() => {
    fetchMembershipDetails();
  }, [memberShipId]);

  console.log(complaintDetails);

  const ComplaintDetails: IDataTableProps = {
    isPagination: true,
    isDataLoading: Loading,
    totalRecords: totalRecords,
    rowsPerPageOptions: tablePagination.rowsInPerPage,
    tableCommandBarProps: {
      leftItems: {
        customPlugins: [
          {
            key: "byDate",

            onRender: () => (
              <DateFilterDropdown
                value={type}
                options={dateDropdownList}
                onChange={handleDateSelectChange}
              />
            ),
          },
          {
            key: "fromDate",
            onRender: () =>
              type === "custom" ? (
                <CustomDatePicker
                  sx={{ minWidth: "142px" }}
                  value={date.fromDate}
                  onChange={(newValue) => {
                    const newDate = moment(newValue).format("YYYY-MM-DD");
                    setDate({ ...date, fromDate: newDate });
                  }}
                />
              ) : (
                <></>
              ),
          },
          {
            key: "toDate",
            onRender: () =>
              type === "custom" ? (
                <CustomDatePicker
                  sx={{ minWidth: "142px" }}
                  value={date.toDate}
                  onChange={(newValue) => {
                    const newDate = moment(newValue).format("YYYY-MM-DD");
                    setDate({ ...date, toDate: newDate });
                  }}
                />
              ) : (
                <></>
              ),
          },
          {
            key: "refresh",
            onRender: () => <RefreshPlugin onClick={fetchMembershipDetails} />,
          },
          {
            key: "csvExport",
            onRender: (columns, items) => (
              <CSVExportPlugin
                columns={columns}
                items={items}
                filePrefixName="Report"
              />
            ),
          },
        ],
      },
      rightItems: {
        plugins: {
          searchField: {
            searchKeys: ["user_name"],
            items: complaintDetails,
          },
        },
      },
    },
    mobileLogo: {
      type: MobileLogoRenderType.reactNode,
      onMobileLogoRender: (data: any) => {
        return (
          <Avatar
            sx={{
              width: 45,
              height: 45,
              color: "#fff",
              ml: "-8px",
              mr: 2,
            }}
          ></Avatar>
        );
      },
    },
    columns: [
      {
        key: "service_status",
        headerName: "Status",
        fieldName: "service_status",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "complaint_no",
        headerName: "Complaint No.",
        fieldName: "complaint_no",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "user_name",
        headerName: "Name",
        fieldName: "user_name",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },

      {
        key: "reg_contact_no",
        headerName: "Mobile Number",
        fieldName: "reg_contact_no",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "vehicle_number",
        headerName: "Vehicle Number",
        fieldName: "vehicle_number",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "vehicle_make",
        headerName: "Brand",
        fieldName: "vehicle_make",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "vehicle_model",
        headerName: "Model Name",
        fieldName: "vehicle_model",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },

      {
        key: "service_city",
        headerName: "Service City",
        fieldName: "service_city",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "fault_type",
        headerName: "Fault Type",
        fieldName: "fault_type",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "fault",
        headerName: "Fault ",
        fieldName: "fault",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "sub_fault",
        headerName: "Sub Fault",
        fieldName: "sub_fault",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
    ],
    items: complaintDetails,
    onPageChange: (newPageNumber: number) => {
      setTablePagination({ ...tablePagination, pageNumber: newPageNumber });
    },
    onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
      setTablePagination({
        pageNumber: pageNumber,
        rowsInPerPage: rowsPerPage,
      });
    },
  };

  console.log(tablePagination.rowsInPerPage);

  console.log(serviceDetails);

  const selectedTransaction = transactions.find(
    (x) => x.membership_code === memberShipId
  );

  const vehicleNumbers = transactions.map(
    (transaction) => transaction.vehicle_number
  );

  console.log(selectedTransaction, "selectedTransaction");

  return (
    <PageContainer title="Call Center" description="this is innerpage">
      {/* <Breadcrumb title="Call Center" items={BCrumb} /> */}
      <StandadCard heading="Complaint Registration ">
        {/* <h3>Complaint Registration</h3> */}
        <Grid container spacing={2}>
          <Grid item xs={12} lg={3}>
            <CustomFormLabel>Search By</CustomFormLabel>
            <CustomSelect
              value={searchType}
              fullWidth
              onChange={(e) => setSearchType(e.target.value as "Mobile Number")}
            >
              <MenuItem value="Mobile Number">Mobile Number</MenuItem>
              <MenuItem value="Vehicle Number">Vehicle Number</MenuItem>
              <MenuItem value="certificate_number">
                Partner Certificate number
              </MenuItem>{" "}
            </CustomSelect>
          </Grid>
          <Grid item xs={12} lg={3}>
            <CustomFormLabel>Enter {searchType}</CustomFormLabel>
            <CustomTextField
              variant="outlined"
              size="small"
              type="string"
              fullWidth
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          </Grid>
          <Grid
            item
            xs={12}
            lg={2}
            sx={{ display: "flex", alignItems: "flex-end" }}
          >
            <Button
              variant="contained"
              type="button"
              fullWidth
              disabled={Loading}
              color="primary"
              onClick={handleSearch}
            >
              Search
            </Button>
          </Grid>
        </Grid>
        {loading === LoadState.InProgress && (
          <StandadCard heading="Relation Ship With Crossroads" sx={{ mt: 2 }}>
            <Grid item xs={12} lg={12}>
              {loading === LoadState.InProgress && (
                <Box
                  display="flex"
                  flexDirection={"column"}
                  justifyContent="center"
                  alignItems={"center"}
                  sx={{ minHeight: "140px" }}
                >
                  <CircularProgress size={23} />
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    Please wait....
                  </Typography>
                </Box>
              )}
            </Grid>
          </StandadCard>
        )}

        {isTranactionsExists && loading === LoadState.Loaded && (
          <>
            <Divider sx={{ marginTop: 4, marginBottom: 0 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} lg={6}>
                <CustomFormLabel>Choose Vehicle Number</CustomFormLabel>
                <CustomSelect
                  value={vechicleNumber}
                  fullWidth
                  onChange={(e) => setvehicleNumber(e.target.value as number)}
                >
                  {transactions.map((transaction, index) => {
                    return (
                      <MenuItem value={index}>
                        {transaction.vehicle_number}
                      </MenuItem>
                    );
                  })}
                </CustomSelect>
              </Grid>
              <Grid item xs={12} lg={6}>
                <CustomFormLabel>Choose Membership Code</CustomFormLabel>
                <CustomSelect
                  value={memberShipId}
                  fullWidth
                  onChange={(e) => setMemberShipId(e.target.value as string)}
                >
                  {(
                    transactions.filter(
                      (x) =>
                        x.vehicle_number ===
                        transactions[vechicleNumber].vehicle_number
                    ) || ([] as IUserMembership[])
                  ).map((transaction) => {
                    return (
                      <MenuItem value={transaction.membership_code}>
                        {transaction.membership_code}
                      </MenuItem>
                    );
                  })}
                </CustomSelect>
              </Grid>
            </Grid>
            {/* <StandadCard heading="Sales Record" sx={{ marginTop: 2 }}>
              <Box
                sx={{
                  padding: 2,
                  borderRadius: 1,
                  m: 2,
                  backgroundColor: "background.default",
                }}
              >
                <CustomTypography variant="body1" sx={{ mb: 1 }}>
                  Based on the filter values you have selected from the table,
                  here are the results:
                </CustomTypography>

                {serviceDetails ? (
                  <Grid container spacing={0}>
                    <Grid item xs={12} md={2}>
                      <CustomTypography variant="h5" fontWeight={"bold"}>
                        Membership Code
                      </CustomTypography>
                      <CustomTypography variant="h3" fontWeight={"bold"}>
                        {serviceDetails.membership_code}
                      </CustomTypography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <CustomTypography variant="h5" fontWeight={"bold"}>
                        Total Services
                      </CustomTypography>
                      <CustomTypography variant="h3" fontWeight={"bold"}>
                        {serviceDetails.total_services}
                      </CustomTypography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <CustomTypography variant="h5" fontWeight={"bold"}>
                        Used Services
                      </CustomTypography>
                      <CustomTypography variant="h3" fontWeight={"bold"}>
                        {serviceDetails.used_services}
                      </CustomTypography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <CustomTypography variant="h5" fontWeight={"bold"}>
                        Remain Services
                      </CustomTypography>
                      <CustomTypography variant="h3" fontWeight={"bold"}>
                        {serviceDetails.remain_services}
                      </CustomTypography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <CustomTypography variant="h5" fontWeight={"bold"}>
                        Services Start
                      </CustomTypography>
                      <CustomTypography variant="h3" fontWeight={"bold"}>
                        {new Date(
                          serviceDetails.membership_start_date
                        ).toLocaleDateString()}
                      </CustomTypography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <CustomTypography variant="h5" fontWeight={"bold"}>
                        Services End
                      </CustomTypography>
                      <CustomTypography variant="h3" fontWeight={"bold"}>
                        {new Date(
                          serviceDetails.membership_expiry_date
                        ).toLocaleDateString()}
                      </CustomTypography>
                    </Grid>
                  </Grid>
                ) : (
                  <Typography variant="body1">
                    No service details found.
                  </Typography>
                )}
              </Box>
            </StandadCard> */}
          </>
        )}
      </StandadCard>
      {/* ====================== membership details ==================== */}

      {/*************************************************** */}
      {!isTranactionsExists && loading === LoadState.Loaded && (
        <Card sx={{ m: 0, marginTop: 4 }}>
          <Box
            sx={{ borderBottom: 1, marginBottom: 3, borderColor: "divider" }}
          >
            <Tabs value={tab} onChange={handleChange}>
              <Tab
                sx={{ minHeight: "50px" }}
                icon={<Money />}
                iconPosition="start"
                label="Paid Service"
                {...a11yProps(0)}
              />
            </Tabs>
            <TabPanel value={tab} index={0}>
              <PaidComplaintLog enteredNumber={value} />
            </TabPanel>
          </Box>

          <TabPanel value={tab} index={2}>
            {selectedTransaction && (
              <PaidComplaintLog
                key={memberShipId}
                selectedMobileNumber={selectedTransaction.contact_number}
                selectedVechileNumber={selectedTransaction.vehicle_number}
                selectedMemberShip={selectedTransaction}
                isFamilyPlan={familyPlan}

              />
            )}
          </TabPanel>
        </Card>
      )}

      {/*************************************************** */}
      {isTranactionsExists && (
        <Card sx={{ m: 0, marginTop: 4 }}>
          <Box
            sx={{ borderBottom: 1, marginBottom: 3, borderColor: "divider" }}
          >
            <Tabs value={tab} onChange={handleChange}>
              <Tab
                icon={<GridView />}
                iconPosition="start"
                label="Package & Vehicle Info"
                {...a11yProps(0)}
              />
              {(auth.user.user_id !== 2211 || (selectedTransaction?.partner_id && selectedTransaction.partner_id > 2)) && <Tab
                sx={{ minHeight: "50px" }}
                icon={<Feed />}
                iconPosition="start"
                label="Register Complaint"
                {...a11yProps(1)}
              />}

              {(auth.user.user_id !== 2211 || (selectedTransaction?.partner_id && selectedTransaction.partner_id > 2)) && <Tab
                sx={{ minHeight: "50px" }}
                icon={<Money />}
                iconPosition="start"
                label="Paid Service"
                {...a11yProps(2)}
              />}
              <Tab
                sx={{ minHeight: "50px" }}
                icon={<GridView />}
                iconPosition="start"

                label="Package Details"
                {...a11yProps(3)}
              />
              <Tab
                sx={{ minHeight: "50px" }}
                icon={<Description />}
                iconPosition="start"
                label="Complaint History"
                {...a11yProps(4)}
              />
              {familyPlan && (
                <Tab
                  sx={{ minHeight: "50px" }}
                  icon={<Add />}
                  iconPosition="start"
                  label=" Add New Vehicle"
                  {...a11yProps(5)}
                />
              )}
            </Tabs>
          </Box>
          <TabPanel value={tab} index={0}>
            <PackageView memberShips={transactions} />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            {selectedTransaction && (
              <ComplaintLog
                key={memberShipId}
                selectedMobileNumber={selectedTransaction.contact_number}
                selectedVechileNumber={selectedTransaction.vehicle_number}
                selectedMemberShip={selectedTransaction}
                isFamilyPlan={familyPlan}
              />
            )}
          </TabPanel>
          <TabPanel value={tab} index={2}>
            {selectedTransaction && (
              <PaidComplaintLog
                key={memberShipId}
                selectedMobileNumber={selectedTransaction.contact_number}
                selectedVechileNumber={selectedTransaction.vehicle_number}
                selectedMemberShip={selectedTransaction}
                isFamilyPlan={familyPlan}
              />
            )}
          </TabPanel>
          <TabPanel value={tab} index={3}>
            {selectedTransaction && (
              <ServiceDetails key={memberShipId} membershipId={memberShipId} />
            )}
          </TabPanel>
          <TabPanel value={tab} index={4}>
            {selectedTransaction && (
              <ComplaintReport key={memberShipId} membershipId={memberShipId} />
            )}
          </TabPanel>
          <TabPanel value={tab} index={5}>
            {familyPlanData && familyPlan && (
              <AddVehicle
                key={memberShipId}
                selectedMobileNumber={familyPlanData.contact_number}
                selectedMemberShip={familyPlanData}
                memberID={familyPlanData.membership_code}
              />
            )}
          </TabPanel>
        </Card>
      )}
      {/* {isTranactionsExists && loading === LoadState.Loaded && (
        <StandadCard heading="Previous Complaint Details" sx={{ mt: 4 }}>
          <DataTable {...ComplaintDetails} />
        </StandadCard>
      )} */}
    </PageContainer>
  );
};

/**
 {loading !== LoadState.NotLoaded &&
        <CustomerTrackTable
        loading={loading}
        customerTrackList={list}
        relationShipBy={type}
        relationShipByValue={value}
      />
       }
 */
